import React, { Component } from "react";
import Field from "./Field";
import FormNav from "./FormNav";
import Yup from "yup";
import _ from "lodash";

class Preview extends Component {
  constructor(props) {
    super(props);
    // console.log("PREVIEW PROPS", props);
    this.state = {
      data: props.data,
      errors: {},
      validated: false,
      validationSchema: this.generateValidationSchema(
        this.props.application.schemas
      )
    };

    this.generateValidationSchema = this.generateValidationSchema.bind(this);
    this.setDestination = this.setDestination.bind(this);
    this.validate = this.validate.bind(this);
  }

  componentWillMount() {
    this.validate();
  }

  componentDidMount() {
    // this.form.submitButton.click();
    // console.log(this.form);
  }

  componentWillReceiveProps(nextProps) {
    if (
      !_.isEqual(this.state.data, nextProps.data) &&
      !_.isEmpty(nextProps.data) &&
      !_.isUndefined(nextProps.data)
    ) {
      // console.log("componentWillReceiveProps", nextProps.data);
      this.setState(
        {
          data: nextProps.data,
          validated: false
        },
        this.validate
      );
    }
  }

  generateValidationSchemaField(requiredFields, uiSchema = {}, field, id) {
    // console.log("generateValidationSchemaField", id, field.type);
    let valObj = Yup;
    if (field.type === "string") {
      valObj = valObj.string();
    }
    if (field.type === "number") {
      valObj = valObj.number().typeError("This value must be a number.");
    }
    if (field.type === "array") {
      if (
        "ui:widget" in uiSchema[id] &&
        (uiSchema[id]["ui:widget"] === "object" ||
          uiSchema[id]["ui:widget"] === "table")
      ) {
        let transformedSubschema = {};
        if ("items" in field) {
          _.forIn(field.items.properties, (array_field, array_id) => {
            transformedSubschema[
              array_id.substring(array_id.indexOf(".") + 1)
            ] = this.generateValidationSchemaField(
              requiredFields,
              uiSchema[id].items,
              array_field,
              array_id
            );
          });
        }
        // console.log("transformed SUBSCHEMA", transformedSubschema);
        valObj = valObj.array().of(Yup.object().shape(transformedSubschema));
      } else {
        valObj = valObj.array();
      }
    }
    if (
      id in uiSchema &&
      "ui:widget" in uiSchema[id] &&
      uiSchema[id]["ui:widget"] === "email"
    ) {
      valObj = valObj.email("Invalid email");
    }
    if (
      id in uiSchema &&
      "ui:widget" in uiSchema[id] &&
      uiSchema[id]["ui:widget"] === "uri"
    ) {
      valObj = valObj.url("Invalid URL. Please include http or https.");
    }
    if ("minimum" in field) {
      valObj = valObj.min(
        field.minimum,
        "This amount must be no less than ${max}"
      );
    }
    if ("maximum" in field) {
      valObj = valObj.max(
        field.maximum,
        "This amount must be no more than ${max}"
      );
    }
    if (requiredFields.indexOf(id) > -1) {
      valObj = valObj.required("Required field");
      // console.log(`${id} required`);
    }
    if ("maxLength" in field && field.maxLength !== "") {
      valObj = valObj.max(
        parseInt(field.maxLength, 10),
        `Maximum of ${field.maxLength} characters`
      );
    }
    if ("minLength" in field && field.minLength !== "") {
      valObj = valObj.min(
        parseInt(field.minLength, 10),
        `Minimum of ${field.minLength} characters`
      );
    }

    return valObj;
  }

  generateValidationSchema(schemas) {
    let transformedSchema = {};

    schemas.map(page => {
      let schema = page.schema;
      let uiSchema = page.uiSchema;
      // console.log("schema", schema);
      return _.forIn(schema.properties, (field, id) => {
        // console.log("mappin", field, id, schema.required);
        transformedSchema[id] = this.generateValidationSchemaField(
          "required" in schema ? schema.required : [],
          uiSchema,
          field,
          id
        );
      });
    });

    // console.log("transformedSchema", transformedSchema);

    return Yup.object().shape(transformedSchema);
  }

  validate() {
    let { validationSchema, data, validated } = this.state;
    let aggregatedErrors = {};
    // console.log("validate called", validationSchema, data);
    if (!_.isEmpty(data) && !_.isUndefined(data) && !validated) {
      return validationSchema
        .validate(data, { abortEarly: false })
        .then(value => {
          // console.log("value", value);
          this.setState({ errors: {}, validated: true });
        })
        .catch(err => {
          // console.log("err", err);
          "inner" in err &&
            err.inner.forEach(error => {
              aggregatedErrors[error.path] = error.message;
            });
          // console.log("errors", aggregatedErrors);
          this.setState({ errors: aggregatedErrors, validated: true });
        });
    }
  }

  setDestination(destination) {
    return this.props.history.push(destination);
  }

  render() {
    let {
      isApplicationOpen,
      application,
      appID,
      data,
      history,
      isSubmitting,
      logout,
      match,
      submitSubmission,
      isSubmitted,
      timeSubmitted,
      user
    } = this.props;

    let { errors } = this.state;
    let description = "";
    let contactEmail = application.contactEmail || 'LeadersEurope@obama.org'
    if (isSubmitted && timeSubmitted) {
      if ("dateClose" in application && timeSubmitted > application.dateClose) {
        description = (
          <div className="alert alert-danger">
            This application was submitted after the deadline at{" "}
            {(timeSubmitted.toDate().toString())}.
          </div>
        );
      } else {
        description = (
          <div className="alert alert-primary">
            This application was submitted at {(timeSubmitted.toDate().toString())}. You
            may review your application below.
          </div>
        );
      }
    } else if (isApplicationOpen) {
      description = (
        <p>
          Please ensure all the information below is accurate before you submit
          your application. 
          <br /><br /> 
          If your application answers are not appearing below, or you are having other technical difficulties submitting your application, 
          please email <a href={'mailto:'+contactEmail || 'Leaders'}>{contactEmail}</a>
        </p>
      );
    } else {
      description = (
        <p>
          This application is closed and no further submissions will be taken.
        </p>
      );
    }

    return (
      <div className="row">
        <FormNav
          appID={appID}
          application={application}
          history={history}
          isApplicationOpen={isApplicationOpen}
          logout={logout}
          match={match}
          orientation="vertical"
          setDestination={this.setDestination}
          isSubmitted={isSubmitted}
          user={user}
        />
        <div className="col col-md-8 col-lg-9 py-4" id="preview">
          <h2>Review</h2>
          {description}
          {this.state.validated &&
            data &&
            application.schemas.map((schema, pageNum) => {
              let currentSchema = schema.schema;
              let currentUiSchema = schema.uiSchema;
              let currentFields =
                currentUiSchema["ui:order"] ||
                Object.keys(currentSchema.properties);

              return (
                <div className="form-wrapper" key={pageNum}>
                  <hr />
                  <h3>{currentSchema.title}</h3>
                  {currentFields.map(id => {
                    return (
                      <Field
                        application={application}
                        errors={errors || {}}
                        id={id}
                        key={id}
                        pageNum={pageNum}
                        preview={true}
                        required={currentSchema.required.indexOf(id) > -1}
                        schema={currentSchema.properties[id]}
                        uiSchema={currentUiSchema[id]}
                        value={id in data ? data[id] : ""}
                        values={data}
                        {...this.props}
                      />
                    );
                  })}
                </div>
              );
            })}
          {isApplicationOpen && (
            <div>
              {!_.isEmpty(errors) && (
                <p className="font-sans float-left text-danger">
                  Please fix the errors above.
                </p>
              )}
              {!isSubmitted && (
                <button
                  className="btn btn-primary float-right nav-btn"
                  disabled={
                    !_.isEmpty(errors) ||
                    isSubmitting ||
                    !this.state.validated ||
                    _.isEmpty(this.state.data) ||
                    _.isUndefined(this.state.data)
                  }
                  onClick={submitSubmission}
                >
                  {application.content.submitButton}
                </button>
              )}
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default Preview;



// WEBPACK FOOTER //
// ./src/Preview.js